import { openLink, openTelegramLink, shareURL } from '@telegram-apps/sdk-react';

/** Внешняя ссылка (карты): через Telegram, вне его — новая вкладка. */
export function openExternal(url: string): void {
  if (openLink.isAvailable()) {
    openLink(url, { tryInstantView: false });
    return;
  }
  window.open(url, '_blank', 'noopener');
}

/** Ссылка t.me (группа отряда, поддержка): внутри Telegram открывается без выхода из клиента. */
export function openTelegram(url: string): void {
  if (openTelegramLink.isAvailable()) {
    openTelegramLink(url);
    return;
  }
  window.open(url, '_blank', 'noopener');
}

/** Поделиться ссылкой: нативный шаринг Telegram, иначе — буфер обмена. Возвращает true, если скопировано. */
export async function shareOrCopy(url: string, text: string): Promise<'shared' | 'copied' | 'failed'> {
  if (shareURL.isAvailable()) {
    shareURL(url, text);
    return 'shared';
  }
  try {
    await navigator.clipboard.writeText(url);
    return 'copied';
  } catch {
    return 'failed';
  }
}

export function canShare(): boolean {
  return shareURL.isAvailable();
}

/** Машинный код ошибки API (`error.data.reason`, ADR-13). */
export function apiReason(e: unknown): string | undefined {
  return (e as { data?: { reason?: string } }).data?.reason;
}
